import React from "react";
import { Link } from "react-router-dom";

const AdvertiseItem = ({ advertise }) => {
  const { donation, poster } = advertise || {};
  const { donationId, donationTitle } = donation || {};
  return (
    <div className="relative">
      <div
        className="w-full h-full bg-center bg-cover bg-no-repeat"
        style={{
          backgroundImage: `url(${poster})`,
        }}
      >
        <div className="w-full flex justify-center items-center absolute bottom-32">
          {donationId && (
            <Link
              to={`/donation/${donationId}/${donationTitle}`}
              className="py-8 px-32 bg-gray-800 rounded-full text-white text-5xl border-gray-50 border-4"
            >
              Touch to Donate
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdvertiseItem;
